"use client";

import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

type Props = {};

const ScrollToTopArrow = (props: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);
  return (
    <div>
      {isVisible && (
        <div
          className="fixed w-[50px] group top-32 aspect-square right-0 flex items-center justify-center bg-main-dark-green-light text-white rounded-l-2xl cursor-pointer hover: transition-all z-[999]"
          onClick={scrollToTop}
        >
          <FaArrowUp
            size={24}
            className="group-hover:text-main-accent transition-all"
          />
        </div>
      )}
    </div>
  );
};

export default ScrollToTopArrow;
